import React, { useState } from 'react';
import { FC } from 'react';
import { useGet } from '../../hooks/useApi';
import { tenantApi } from '../../APIs/tenants';
import { reformat } from '../../utils/DateUtils';
import { comma } from '../../utils/FormUtils';
import { SpinnerIcon } from '../atomic/icons';
import { TaskSummaryModel } from '../../models/TaskModel';
import { useAuth } from '../../contexts/AuthContext';

const useGetStatus = (tenantId?: string) => {
    const { isSuperAdmin } = useAuth();
    const { data: status } = useGet(
        isSuperAdmin()
            ? null //tenantApi.get.getTenantStatusForSuperAdmin(tenantId)
            : tenantApi.get.getTenantStatus
    );
    const { data: tenants } = useGet(
        isSuperAdmin() ? tenantApi.get.getTenantsForSuperAdmin : null
    );
    const selectedStatus = React.useMemo(() => {
        if (tenantId && tenants?.data) {
            return tenants.data.find((tenant) => {
                return tenant.tenantId === tenantId;
            });
        } else if (tenants?.data) {
            const total = tenants.data.reduce(
                (t, tenant) => {
                    return {
                        size: t.size + tenant.size,
                        availableStorageSize:
                            t.availableStorageSize +
                            tenant.availableStorageSize,
                        usage: 0,
                        finishedAt: tenant.finishedAt,
                        aiRequestCount:
                            t.aiRequestCount + tenant.aiRequestCount,
                        maxAiRequest: t.maxAiRequest + tenant.maxAiRequest,
                    };
                },
                {
                    size: 0,
                    availableStorageSize: 0,
                    usage: 0,
                    finishedAt: new Date().toISOString(),
                    aiRequestCount: 0,
                    maxAiRequest: 0,
                }
            );
            total.usage = Number(
                ((total.size / total.availableStorageSize) * 100).toFixed(2)
            );
            return total;
        }
        return null;
    }, [tenantId, tenants]);
    return { status: isSuperAdmin() ? selectedStatus : status?.data };
};

type Prop = { tasks: TaskSummaryModel[]; month: string; tenantId?: string };
export const TenantStorageStatus: FC<Prop> = ({ tasks, month, tenantId }) => {
    const { status } = useGetStatus(tenantId);
    if (!status) {
        return <></>;
    }
    return (
        <>
            <ul className="tenant-status-list">
                <li>
                    <b>ストレージ使用量:</b> {comma(status?.size)} GB
                </li>
                <li>
                    <b>最大サイズ:</b> {comma(status?.availableStorageSize)} GB
                </li>
                <li>
                    <b>使用率:</b> {status?.usage}%
                </li>
                <li>
                    <b>取得日:</b> {reformat(status.finishedAt)}
                </li>
            </ul>
        </>
    );
};

export const TenantAIStatus: FC<Prop> = ({ tasks, month, tenantId }) => {
    const { isSuperAdmin } = useAuth();

    const { status } = useGetStatus(tenantId);

    if (!status) {
        return <></>;
    }
    const count =
        tasks.length &&
        tasks.reduce(function (total: number, item: TaskSummaryModel) {
            return total + item.image;
        }, 0);
    return (
        <>
            <ul className="tenant-status-list">
                {!isSuperAdmin() && status.maxAiRequest > 0 && (
                    <li>
                        <b>当月推論枚数:</b>
                        {comma(status.aiRequestCount)}/
                        {comma(status.maxAiRequest)}枚
                    </li>
                )}
                {month.length > 0 && (
                    <li>
                        <b>{month}推論画像数:</b>
                        {comma(count)}枚
                    </li>
                )}
            </ul>
        </>
    );
};
